<app-navbar></app-navbar>

<div class="page-wrap">
  <div class="card">
    <h1 class="title">Psychotherapy Wait List</h1>
    <p class="subtitle">Our wait list for therapy in North Carolina is about six months.</p>
    
    <div class="providers-section ">
      <h2 class="join-message">If you need care sooner than that, we recommend the following trusted providers:</h2>
      <div class="providers-list">
        <div class="provider-item">
          <div><a href="tel:9195143566" class="provider-name">Three Oaks Behavioral Health and Wellness</a></div>
          <div class="provider-phone">(919) 514-3566</div>
        </div>
        <div class="provider-item">
          <div><a href="tel:9192299834" class="provider-name">Aspire Counseling Group</a></div>
          <div class="provider-phone">(919) 229-9834</div>
        </div>
        <div class="provider-item">
          <div><a href="tel:9199091230" class="provider-name">Family Solutions and Wellness Center</a></div>
          <div class="provider-phone">(919) 909-1230</div>
        </div>
      </div>
      <p class="join-message">If you still wish to join our wait list, please fill out the form below.</p>
    </div>

    <div class="checkbox-section">
      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="emailConsent" />
        <span>I want to receive email news and updates from Animo Sano Psychiatry.</span>
      </label>
    </div>

    <div class="actions">
      <button type="button" class="btn outline" (click)="onReturn()">No, Return To Scheduling</button>
      <button type="button" class="btn primary" (click)="onJoin()">Yes, Add Me To The Waiting List</button>
    </div>
  </div>
</div>

<app-footer></app-footer>

<div class="wl-overlay" *ngIf="showFormModal">
  <app-loader *ngIf="isSubmitting" [fullscreen]="true" [message]="'Saving'"></app-loader>
  <div class="wl-modal">
    <div class="wl-modal-header">
      <div class="wl-modal-title">Waiting List</div>
      <button class="wl-modal-close" (click)="closeFormModal()">✕</button>
    </div>
    <div class="wl-modal-body">
      <div class="wl-field">
        <label>Full Name<span class="wl-req">*</span></label>
        <input class="wl-input" type="text" maxlength="40" [(ngModel)]="fullName" />
        <div class="wl-invalid" *ngIf="formErrors.fullName">{{ formErrors.fullName }}</div>
      </div>
      <div class="wl-field">
        <label>Phone Number<span class="wl-req">*</span></label>
        <input class="wl-input" type="tel" maxlength="12"  [(ngModel)]="phoneNumber" (input)="onPhoneInput($event)" (keydown)="onPhoneKeydown($event)" />
        <div class="wl-invalid" *ngIf="formErrors.phoneNumber">{{ formErrors.phoneNumber }}</div>
      </div>
      <div class="wl-field">
        <label>Email Address<span class="wl-req">*</span></label>
        <input class="wl-input" type="email" maxlength="40" [(ngModel)]="emailAddress" />
        <div class="wl-invalid" *ngIf="formErrors.emailAddress">{{ formErrors.emailAddress }}</div>
      </div>
      <div class="wl-field">
        <label>Birth Date<span class="wl-req">*</span></label>
        <app-calendar [(ngModel)]="birthDate" name="wlDob" [required]="true" placeholder="MM-DD-YYYY"></app-calendar>
        <div class="wl-invalid" *ngIf="formErrors.birthDate">{{ formErrors.birthDate }}</div>
      </div>
    </div>
    <div class="wl-modal-footer">
      <div class="wl-error" *ngIf="submitError">{{ submitError }}</div>
      <button class="btn wl-join-btn" [disabled]="isSubmitting" (click)="submitWaitlist()">{{ isSubmitting ? 'Submitting…' : 'Join Our Waiting List' }}</button>
    </div>
  </div>
</div>

<div class="wl-overlay" *ngIf="showSuccessModal">
  <div class="wl-modal wl-success">
    <div class="wl-modal-header">
      <div class="wl-modal-title">Waiting List</div>
      <button class="wl-modal-close" (click)="onReturn()">✕</button>
    </div>
    <div class="wl-success-body">
      <div class="wl-check">✓</div>
      <div class="wl-thanks">Thanks!</div>
      <div class="wl-sub">You are on our North Carolina Psychotherapy waiting list.</div>
    </div>
  </div>
</div>

<div class="wl-toast" *ngIf="submitError">
  <div class="wl-toast-body">
    <div class="wl-toast-title">Error</div>
    <div class="wl-toast-msg">{{ submitError }}</div>
  </div>
  <button class="wl-toast-close" (click)="submitError=''" aria-label="Close">✕</button>
  <div class="wl-toast-progress"></div>
  </div>


